export default __webpack_public_path__ + "static/media/wsf2018.7cee9199.png";